var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-grid__item m-grid__item--fluid m-wrapper" },
    [
      _c("div", { staticClass: "m-subheader" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("div", { staticClass: "mr-auto" }, [
            _c(
              "ul",
              { staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline" },
              [
                _c(
                  "li",
                  { staticClass: "m-nav__item" },
                  [
                    _c("router-link", { attrs: { to: { name: "home" } } }, [
                      _c("span", { staticClass: "m-nav__link-text" }, [
                        _c("i", { staticClass: "m-nav__link-icon la la-home" })
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__separator" }, [
                  _vm._v("\n\t\t  \t\t\t\t>\n\t\t  \t\t\t")
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__item" }, [
                  _c("a", { staticClass: "m-nav__link", attrs: { href: "" } }, [
                    _c("span", { staticClass: "m-nav__link-text" }, [
                      _vm._v(
                        "\n\t\t  \t\t\t\t\t\t" +
                          _vm._s(
                            _vm._f("titleize")(
                              _vm._f("translate")("my_profile")
                            )
                          ) +
                          "\n\t\t  \t\t\t\t\t"
                      )
                    ])
                  ])
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-content" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            Object.keys(_vm.user_data).length > 0
              ? _c("s-bar-container", { attrs: { user: _vm.user_data } })
              : _vm._e(),
            _vm._v(" "),
            Object.keys(_vm.user_data).length > 0
              ? _c("s-profile-container", { attrs: { user: _vm.user_data } })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-577e748b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-577e748b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/profile/Profile.vue
// module id = 830
// module chunks = 0 1 72